export const AdminNames = {
  Account: 'account',
  AccountLogin: 'account.login',
  SingleMain: 'single.main.noLogin',
  SingleActivity: 'single.activity.noLogin',
  SingleActivityMobile: 'single.activity.mobile.noLogin',
  SingleActivityFinaList: 'single.activity.fina.list',
  SingleActivityEnroll: 'single.activity.enroll',
  SingleExport: 'single.export',
  SingleInstitution: 'single.institution.noLogin',
  SingleResult: 'single.result',
  SingleScreenshot: 'single.screenshot.noLogin',
  SingleHome: 'single.home.noLogin',
  HomeWonderfulReview: 'home.wonderful.review.noLogin',
  SingleSliceHome: 'single.slice.home.noLogin',
  SingleSliceActivity:'single.slice.home.activity',

  SingleWonderfulReview:'single.wonderful.review',

  Admin: 'admin',
  AdminUser: 'admin.user',
  AdminUserStudent: 'admin.user.student',
  AdminBackStudent: 'admin.user.back',
  AdminUserRole: 'admin.user.role',

  AdminOrg: 'admin.org',
  AdminOrgCenter: 'admin.org.center',
  AdminOrgCenterVip: 'admin.org.center.vip',

  AdminOperation: 'admin.operation',
  AdminOperationCenter: 'admin.operation.center',
  AdminOperationAdd: 'admin.operation.add',
  AdminOperationSign: 'admin.operation.sign',
  AdminOperationFina: 'admin.operation.fina',
  AdminOperationResult: 'admin.operation.result',
  AdminOperationAssay: 'admin.operation.assay', //分析
  MobileAdminOperationCenter: 'admin.operation.center.mobile',
  AdminOperationCertificate: 'admin.operation.certificate'
  // AdminOrgCenterVip: 'admin.org.center.vip'
};

export const ErrorNames = {
  Err: 'error',
  Err403: 'error.403',
  Err404: 'error.404',
  Err500: 'error.500'
};
